import http from './httpService';

export function deleteRisk(id) {
  return http.delete(`/risks/${id}`);
}

export function deleteLitigationRisk(id) {
  return http.delete(`/court-risks/${id}`);
}
